import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-openapi/system'

const SystemApi = {
  getTimezoneOffset (data, success, failure) {
    return ajax.post(
      BASE_URL + '/get-timezone-offset',
      data,
      success,
      failure,
      { couldCancel: false }
    )
  }
}

export { SystemApi }
